"use client";

export default function CloseIcon({ className = "", ...props }) {
    return (
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"  className={className}
            {...props}>
<path d="M19.73 35.1958C28.2716 35.1958 35.1958 28.2715 35.1958 19.73C35.1958 11.1885 28.2716 4.26419 19.73 4.26419C11.1885 4.26419 4.26422 11.1885 4.26422 19.73C4.26422 28.2715 11.1885 35.1958 19.73 35.1958Z" stroke="currentColor" strokeWidth="2.22423" strokeMiterlimit="10"/>
<path d="M12.4623 12.4623L26.9995 26.9995" stroke="currentColor" strokeWidth="2.22423" strokeMiterlimit="10"/>
<path d="M12.4623 26.9995L26.9995 12.4623" stroke="currentColor" strokeWidth="2.22423" strokeMiterlimit="10"/>
</svg>

    );
}







